module.exports = __webpack_public_path__ + "static/media/lets_talk_awesome-G.dc1ceb44.PNG";